import React from 'react'

const SettingModal = () => {
    return (
        <div>SettingModal</div>
    )
}

export default SettingModal